import TagManagementContainer from 'views/pages/tag-management/TagManagementContainer';

export default TagManagementContainer;
